<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import AppIcon from '@/components/ui/AppIcon.vue'

/**
 * Шапка экрана выбора точки: белая строка 60px со стрелкой назад и
 * заголовком 20 Bold. В макете она есть на самовывозе («Где заберёте?»,
 * на карточке — имя филиала) и появляется, когда экран открыт диалогом.
 */
interface Props {
  title: string
}

defineProps<Props>()

const emit = defineEmits<{
  back: []
}>()

const { t } = useI18n()
</script>

<template>
  <header class="location-header">
    <button type="button" class="location-header__back" :aria-label="t('common.back')" @click="emit('back')">
      <AppIcon name="arrow-left" :size="24" />
    </button>
    <h1 class="location-header__title">{{ title }}</h1>
  </header>
</template>

<style scoped lang="scss">
.location-header {
  display: flex;
  flex: 0 0 60px;
  align-items: center;
  gap: var(--space-5);
  height: 60px;
  padding: 0 var(--screen-padding);
  background: var(--surface-card);

  &__back {
    display: flex;
    flex: 0 0 24px;
    padding: 0;
    border: 0;
    background: none;
    color: var(--icon-color);
    cursor: pointer;
  }

  &__title {
    overflow: hidden;
    font-size: 20px;
    font-weight: var(--fw-bold);
    line-height: 31px;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
